import { z } from 'zod'
import {
  AnalyticsRoutes,
  BroadcastsRoutes,
  ChatbotRoutes,
  ContactsRoutes,
  ConversationRoutes,
  DiscoverRoutes,
} from 'entities/ExportRouters'

/**
 * Main app areas the agent can navigate to, matching the sidebar
 * (widgets/Sidebar/constants/menuItems.ts → menuItemsV2). Labels are the
 * human-facing sidebar names so the model can reason about them naturally.
 *
 * Route roots come from entities/ExportRouters — the same source menuItemsV2
 * uses — rather than importing menuItemsV2 itself (that lives in widgets/, and
 * entities/ importing widgets/ would violate FSD layering).
 */
export const NAV_AREAS = [
  'Inboxes',
  'Discover',
  'AI & Automation',
  'Outbound',
  'Contacts',
  'Analytics',
] as const

export type NavArea = (typeof NAV_AREAS)[number]

export const navigateSchema = z.object({
  area: z.enum(NAV_AREAS).describe('Main app area to navigate to'),
})

export const NAV_AREA_ROUTES: Record<NavArea, string> = {
  Inboxes: ConversationRoutes.root,
  Discover: DiscoverRoutes.root,
  'AI & Automation': ChatbotRoutes.root,
  Outbound: BroadcastsRoutes.root,
  Contacts: ContactsRoutes.root,
  Analytics: AnalyticsRoutes.root,
}
